import React from "react";
import { Redirect, Route, Switch } from "wouter";
import { QueryClient, QueryClientProvider } from "react-query";
import { UserContext, UserType, useUser } from "./lib/user";

import Logout from "./pages/logout";
import PrivateRoute from "./components/PrivateRoute";
import { Toaster } from "react-hot-toast";
import { isMediaWorld } from "./utils/utils";
import { getCookie } from "./utils/cookies";
import UserPopup from "./components/user-popup";

const Login = React.lazy(() => import("./pages/login"));
const Dashboard = React.lazy(() => import("./pages/dashboard"));
const Users = React.lazy(() => import("./pages/users"));
const ViewFile = React.lazy(() => import("./pages/pratica-view"));
const NewFile = React.lazy(() => import("./pages/pratica-new"));
const Log = React.lazy(() => import("./pages/log"));
const Password = React.lazy(() => import("./pages/password"));
const PraticaPadre = React.lazy(() => import("./pages/pratica-padre"));
const DelegaFilePage = React.lazy(() => import("./pages/delega-file-page"));
const NewUser = React.lazy(() => import("./pages/new-user"));

if (isMediaWorld()) {
  document.title = "Lifegate | MediaWorld";
  const favicon: any = document.getElementById("favicon");
  favicon.href = "/samsungFavicon.ico";
}

function Routes() {
  const { user } = useUser();
  const root = "/";

  return (
    <div>
      <Switch>
        <Route path="/login">{user ? <Redirect to={root} /> : <Login />}</Route>
        <Route path="/logout">
          <Logout />
        </Route>
        <Route path="/new-user">
          <NewUser />
        </Route>
        <PrivateRoute path="/password">
          <Password />
        </PrivateRoute>
        <PrivateRoute path="/pratica/new">
          <NewFile />
        </PrivateRoute>
        <PrivateRoute path="/sottopratica/:idPadre/new">
          <NewFile />
        </PrivateRoute>
        <PrivateRoute path="/pratica-padre/:id">
          {process.env.REACT_APP_110 ? (
            <PraticaPadre />
          ) : (
            <Redirect to={root} />
          )}
        </PrivateRoute>
        <PrivateRoute path="/sottopratica/:idPadre/:id">
          {process.env.REACT_APP_110 ? <ViewFile /> : <Redirect to={root} />}
        </PrivateRoute>
        <PrivateRoute path="/pratica/:id">
          <ViewFile />
        </PrivateRoute>
        <PrivateRoute path="/pratica/:id/log">
          <Log />
        </PrivateRoute>
        <PrivateRoute path="/sottopratica/:idPadre/:id/log">
          <Log />
        </PrivateRoute>
        <PrivateRoute path="/">
          {root === "/" ? <Dashboard /> : <Redirect to={root} />}
        </PrivateRoute>
        <PrivateRoute path="/users">
          {user?.type === UserType.Asseveratore ? (
            <Users />
          ) : (
            <Redirect to={root} />
          )}
        </PrivateRoute>
        <Route path="/delega-caricamento-file/:token">
          <DelegaFilePage />
        </Route>
      </Switch>
    </div>
  );
}

const queryClient = new QueryClient();

function App() {
  return (
    <UserContext>
      <QueryClientProvider client={queryClient}>
        <React.Suspense fallback={null}>
          <>
            <Routes />
            {!getCookie("userAlert") && <UserPopup />}
            <Toaster
              toastOptions={{
                className: "",
                style: {
                  maxWidth: "80vw",
                },
              }}
            />
          </>
        </React.Suspense>
      </QueryClientProvider>
    </UserContext>
  );
}

export default App;
